import { render } from "./RiWarning.vue?vue&type=template&id=1e33235f"
import script from "./RiWarning.vue?vue&type=script&lang=js"
export * from "./RiWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e33235f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e33235f', __exports__)) {
    api.reload('1e33235f', __exports__)
  }
  
  module.hot.accept("./RiWarning.vue?vue&type=template&id=1e33235f", () => {
    api.rerender('1e33235f', render)
  })

}


export default __exports__